import React from 'react';

export default function EmptyState({ 
  icon: Icon, 
  title, 
  description, 
  action,
  actionLabel 
}) {
  return (
    <div className="text-center py-12">
      {Icon && <Icon className="mx-auto h-12 w-12 text-gray-400" />}
      <h3 className="mt-2 text-sm font-medium text-gray-900">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-gray-500">{description}</p>
      )}
      {action && actionLabel && (
        <div className="mt-6">
          <button onClick={action} className="btn-primary">
            {actionLabel}
          </button>
        </div>
      )}
    </div>
  );
}
